// breakpoint where swiper will be destroyed
// and switches to a dual-column layout
var breakpoint = window.matchMedia("(min-width:768px)");
// keep track of swiper instances to destroy later
var newsSwiper;

//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
var breakpointChecker = function () {
  // if larger viewport and multi-row layout needed
  if (breakpoint.matches === true) {
    // clean up old instances and inline styles when available
    if (newsSwiper !== undefined) newsSwiper.destroy(true, true);
    // or/and do nothing
    return;
    // else if a small viewport and single column layout needed
  } else if (breakpoint.matches === false) {
    // fire small viewport version of swiper
    return enableSwiper();
  }
};
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
var enableSwiper = function () {
  newsSwiper = new Swiper(".js-slider-news", {
    loop: true,
    // slidesPerView: "auto",
    // centeredSlides: true,
    // a11y: true,
    // keyboardControl: true,
    // grabCursor: true,
    // // pagination
    // pagination: ".swiper-pagination",
    // paginationClickable: true,
  });
};

// var enableSwiper = function () {
//   filterSwiper = new Swiper(".js-slider-filter", {
//     loop: true,
//     // slidesPerView: "auto",
//     // centeredSlides: true,
//     // a11y: true,
//     // keyboardControl: true,
//     // grabCursor: true,
//     // // pagination
//     // pagination: ".swiper-pagination",
//     // paginationClickable: true,
//   });
// };

var swiper = new Swiper('.js-slider-filter', {
  speed: 400,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  slidesPerView: 'auto'
  // freeMode: true
});
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
// keep an eye on viewport size changes
breakpoint.addListener(breakpointChecker);
// kickstart
breakpointChecker();
